import SearchIcon from '@mui/icons-material/Search';
import { Box, Card, MenuItem, Select, SelectChangeEvent, Stack, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import {
  SearchBar,
  WsButton,
  WsColors,
  WsSelectObj,
  WsToggleButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  WsSelect,
} from 'wisestep-base';

import Frame from '../../images/Frame.svg';
export interface WsSearchFilterProps {
  name: string;
  showDefaultRightActions?: boolean;
  rightActionsChildren?: React.ReactNode;
  children?: React.ReactNode;
  showChildren?: boolean;
  showLeftActions?: boolean;
  leftActionsChildren?: React.ReactNode;
  onClickFilter?: () => void;
  sortOptions?: WsSelectObj[];
  sortDefaultValue?: string;
  onSort?: (event: SelectChangeEvent) => void;
  searchPlaceholder?: string;
  clearAllFields?: () => void;
  className?: string;
  searchScopeDefaultValue?: string;
  getSearchScopeIndex?: (value: string | number) => void;
  isJobCrmSearch?: boolean;
  isSpecificSearch?: boolean;
  handleCheckboxChange?: () => void;
  isToggleButtonActive?: boolean;
  searchOptions?: WsSelectObj[];
}
const minMatchScoreList: { label: string; value: string }[] = [];

for (let i = 30; i <= 90; i += 10) {
  const label = i + ' %';
  const value = i.toString();
  minMatchScoreList.push({ label, value });
}

const WsSearchFilter = ({
  showChildren = false,
  children,
  showDefaultRightActions = true,
  rightActionsChildren,
  showLeftActions = false,
  leftActionsChildren,
  onClickFilter,
  sortOptions,
  searchPlaceholder,
  clearAllFields,
  onSort,
  sortDefaultValue,
  className,
  searchScopeDefaultValue,
  getSearchScopeIndex,
  isJobCrmSearch = false,
  handleCheckboxChange,
  isToggleButtonActive = false,
  searchOptions,
}: WsSearchFilterProps) => {
  const [exactMatch, setExactMatch] = useState(isToggleButtonActive);
  return (
    <Box className={className} bgcolor={WsColors.White} borderRadius={1} px={2} py={1}>
      <Grid item>
        {getSearchScopeIndex && (
          <>
            <Grid container item xs={12} alignItems="center">
              <Grid item xs={1.5}>
                <WsTypography bold={true} variant={WsTypoVariants.SUB_TITLE}>
                  Search in
                </WsTypography>
              </Grid>
              <Grid item xs>
                <WsToggleButton
                  buttonsList={[
                    { label: 'CV', value: 'CV' },
                    { label: 'Everywhere', value: 'EVERYTHING' },
                  ]}
                  selectedIndexValue={getSearchScopeIndex}
                  defaultValue={searchScopeDefaultValue ?? 'EVERYTHING'}
                  buttonGroupPadding={6}
                />
              </Grid>
            </Grid>
          </>
        )}
        <Stack direction="row" spacing={1}>
          {isJobCrmSearch && (
            <Grid item xs={2.7} pt={3.5}>
              <WsSelect
                name="searchBy"
                selectArray={searchOptions ?? []}
                placeholder="SearchBy"
                size="small"
              />
            </Grid>
          )}
          <Grid item xs={isJobCrmSearch ? 8.5 : 9.5} pt={isJobCrmSearch ? 3.5 : 2}>
            <Card sx={{ p: 0.5 }}>
              <SearchBar
                name="query"
                placeholder={
                  searchPlaceholder ?? 'Search for Candidate, Skill, Job Title, Location'
                }
              />
            </Card>
          </Grid>
          <Stack direction={'row'} spacing={1} justifyContent="end" pt={isJobCrmSearch ? 3.5 : 2}>
            <WsButton
              className="clear-tags"
              variant="outlined"
              size="large"
              type="reset"
              onClick={clearAllFields}
            >
              Clear
            </WsButton>
            <WsButton variant="outlined" size="large" type="submit" startIcon={<SearchIcon />}>
              Search
            </WsButton>
          </Stack>
        </Stack>
        {className == 'talentpool-filters-1' && (
          <Grid container item xs={12} alignItems="center" mt={1}>
            <Stack spacing={1} direction="row">
              <img src={Frame} alt="Frame Logo" />
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                Exact Match
              </WsTypography>
              <Grid item pt={0.5}>
                <Switch
                  disabled={false}
                  checked={exactMatch}
                  onChange={() => {
                    setExactMatch(!exactMatch);
                    setTimeout(() => handleCheckboxChange && handleCheckboxChange(), 100);
                  }}
                />
              </Grid>
            </Stack>
          </Grid>
        )}
      </Grid>
      {showChildren && (
        <Grid item xs={12}>
          {children}
        </Grid>
      )}

      <Grid container item xs={12} justifyContent={'space-between'} paddingBottom={2}>
        <Grid item xs={7}>
          {showLeftActions && <>{leftActionsChildren}</>}
        </Grid>
        {!showDefaultRightActions && (
          <Grid item xs={sortOptions ? 5 : 3}>
            {rightActionsChildren}
          </Grid>
        )}
        {showDefaultRightActions && (
          <>
            <Grid
              item
              container
              xs={sortOptions ? 'auto' : 3}
              columnGap={1}
              justifyContent="flex-end"
            >
              {sortOptions && (
                <Grid className="sort" item>
                  <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                    Sort by
                  </WsTypography>
                  <Select
                    sx={{ width: 130 }}
                    labelId="select-label-id"
                    id="select-label"
                    label="Sort by"
                    onChange={onSort}
                    defaultValue={sortDefaultValue ?? '_score,desc'}
                    size="small"
                  >
                    {sortOptions.map((option) => {
                      return (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
              )}
              {!(className === 'talentpool-filters') &&
                !location.pathname.includes('pipeline') &&
                !location.pathname.includes('smartSource') && (
                  <Grid item pt={3.7} pb={1.5}>
                    <WsButton
                      className="advanced-filter"
                      variant="outlined"
                      size="large"
                      onClick={onClickFilter}
                      startIcon={<BiFilterAlt />}
                    >
                      Advanced filters
                    </WsButton>
                  </Grid>
                )}
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};
export default WsSearchFilter;
